"use strict";
// @ts-ignore
try {
    self['workbox:precaching:6.4.1'] && _();
}
catch (e) { }
